
import { Platform } from '@angular/cdk/platform';
import {
    Component,
    Inject,
    OnInit
} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { WeekGroup } from 'app/shared/models/sliicer';
import { ExceptionDays, EXCLUDE_DAYS_GROUP_EXCLUDE, EXCLUDE_DAYS_NAME_EXCLUDE } from 'app/shared/models/sliicer/settings';
import { DateutilService } from 'app/shared/services/dateutil.service';
import { SliicerService } from 'app/shared/services/sliicer.service';
import { TrackBy } from 'app/shared/utils/track-by';
import moment from 'moment';

let dateFormat;

export interface ExceptionDaySettingsDialogInputData {
    exceptionDays: ExceptionDays[],
    edit?: ExceptionDays
}

export class CustomDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: string): string {
        return moment(date).format(dateFormat);
    }
}

@Component({
    templateUrl: 'exception-day-settings-dialog.component.html',
    providers: [
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [MAT_DATE_LOCALE, Platform]
          },
    ]
})
export class ExceptionDaySettingsDialogComponent implements OnInit {

    public form: ExceptionDays;
    public caseStudyStartDate: string;
    public caseStudyEndDate: string;
    public isFormChanged = false;

    public validation = {
        isDayGroupNameValid: false,
    }

    public trackByIndex = TrackBy.byIndex;

    public daysGroup: WeekGroup[];

    public excludeExisting: (d: Date) => boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ExceptionDaySettingsDialogInputData,
        public dialogRef: MatDialogRef<ExceptionDays>,
        private sliicerService: SliicerService,
        private dateutilService: DateutilService
    ) {
        dateFormat = this.dateutilService.getDateFormat().toUpperCase();

        const self = this;
        const blockedDates = (self.data.exceptionDays ?? []).map(d => this.dateutilService.convertUTCToLocal(new Date(d.exceptionDate).valueOf()));
        this.excludeExisting = (d: Date) => {
            return (d && !blockedDates.includes(d.valueOf()))
        }

    }

    ngOnInit() {
        this.sliicerService.studyDetailsData$.subscribe((caseStudyDetails) => {
            this.daysGroup = [EXCLUDE_DAYS_GROUP_EXCLUDE, ...caseStudyDetails.settings.dayGroups];

            this.caseStudyStartDate = caseStudyDetails.config.startDate;
            this.caseStudyEndDate = caseStudyDetails.config.endDate;

            if(this.data.edit) {
                this.form = {
                    exceptionDate: this.dateutilService.formatLocalAsUTC(this.data.edit.exceptionDate),
                    dayGroupName: this.data.edit.dayGroupName
                };

                this.validateDayGroupName();
            } else {
                this.form = {
                    exceptionDate: null,
                    dayGroupName: null
                };
            }
        })
    }

    private checkIfFormChanged() {
        if(!this.data.edit) return;

        let isChanged = false;
        if(this.form.dayGroupName !== this.data.edit?.dayGroupName) isChanged = true;

        // Timezone issues, compare dates
        const formDate = new Date(this.dateutilService.formatDateWithoutOffset(new Date(this.form.exceptionDate))).getTime();
        const editDate = new Date(this.data.edit?.exceptionDate).getTime();

        if(formDate !== editDate) isChanged = true;

        this.isFormChanged = isChanged;
    }

    public onExceptionDateChange() {
        this.checkIfFormChanged();
    }

    public onDayGroupNameChange() {
        this.validateDayGroupName();
        this.checkIfFormChanged();
    }

    public validateDayGroupName() {
        this.validation.isDayGroupNameValid = this.daysGroup.some(d => d.name === this.form.dayGroupName);
    }

    public save() {
        this.dialogRef.close({
            dayGroupName: this.form.dayGroupName,
            exceptionDate: this.dateutilService.formatDateWithoutOffset(new Date(this.form.exceptionDate))
        });
    }
}

